import { FC } from 'react';
import { MeasureMarker } from './MeasureMarker';
import { MeasureMark } from './MeasureMark';
import { MEASURE_RANGE_VALUES } from '../state/child-details';

interface HeightMeasureInputProps {
  className?: string;
  onChange?: (value: number) => void;
  value: number;
  unit: 'cm' | 'in';
  max: number;
  min: number;
}

const getMeasurePoints = (max: number, min: number, step = 1) => {
  return Array.from({ length: Math.floor((max - min) / step) + 1 }, (_empty, i) => max - i * step);
};

export const HeightMeasureInput: FC<HeightMeasureInputProps> = ({ onChange, value, unit, max, min }) => {
  const measurePoints = getMeasurePoints(max, min);
  const top =
    MEASURE_RANGE_VALUES.find((range) => range.average === value)?.startPixel ?? MEASURE_RANGE_VALUES[4].fixPixel;
  return (
    <div className="relative pt-5">
      <div className="h-full w-60 flex items-center justify-center">
        <div className="h-107.5 flex flex-col gap-3.5 items-end justify-center select-none">
          {measurePoints.map((measurePoint) => (
            <MeasureMark
              key={measurePoint}
              value={measurePoint}
              unit={unit}
              showAmount={measurePoint % 5 === 0}
              isActive={measurePoint === value}
            />
          ))}
          <MeasureMarker onChange={onChange} initialTop={top} />
        </div>
      </div>
    </div>
  );
};

export default HeightMeasureInput;
